export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_17-d2e9a34c2f426a2717076d120353616c.jpg";